import React from 'react';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';
import useSupplies from './hooks/useSupplies';
import RenderGraphBar from '../../UI/BarChart';
import Icon from 'v2/components/Icon';
import Select from 'v2/components/Select';
import MultiSelectAll from 'components/MultiSelect';

const Supplies: React.FC = () => {
  const {
    selectedInput,
    dataKeyBar,
    optionsSupplies,
    onlyGraphicsAccordingInput,
    selectedShrimpPond,
    setSelectedShrimpPond,
    handleSelectedInput,
  } = useSupplies();

  const renderTextEmptyMessageOrGraph = () => {
    if (
      optionsSupplies.length === 1 &&
      onlyGraphicsAccordingInput.length === 0
    ) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Nenhum dado encontrado
          </Text>
        </Box>
      );
    }

    if (selectedShrimpPond.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Selecione ao menos um viveiro
          </Text>
        </Box>
      );
    }
    return (
      <RenderGraphBar
        data={selectedShrimpPond}
        dataKeyBar={dataKeyBar}
        dataKeyXAxis="pond"
        color={'#005f47'}
      />
    );
  };
  return (
    <Box
      flexDirection="column"
      gap={30}
      padding={30}
      background="#fff"
      borderRadius={18}
    >
      <Box gap={10} alignItems="center">
        <Icon iconName="InventoryOutlined" htmlColor="#005f47" size={30} />
        <Text fontSize={24} fontWeight={700} color="#005f47">
          Gráfico de Insumos
        </Text>
      </Box>

      <Box gap={20}>
        <Select
          backgroundColor="#b7ffbd"
          options={optionsSupplies}
          value={selectedInput}
          labelId="supplies-label"
          selectId="supplies-id"
          label="Insumos"
          onChange={handleSelectedInput}
          defaultValue={'default'}
        />

        <Box>
          <MultiSelectAll
            label="Viveiros"
            id="shrimppond"
            allSelected={
              onlyGraphicsAccordingInput?.length === optionsSupplies?.length
            }
            labelOption="pond"
            onChange={setSelectedShrimpPond}
            options={onlyGraphicsAccordingInput}
            value={selectedShrimpPond}
            error={false}
            helperText={false}
            renderOptionLabel={false}
            labelSelectAllButtonFilterOptions={false}
            labelCustomRenderOption={false}
          />
        </Box>
      </Box>
      {renderTextEmptyMessageOrGraph()}
    </Box>
  );
};

export default Supplies;
